import { useEffect, useState } from 'react';
import { Card } from '@ftedn/ui';
import { useApi } from '../../hooks/useApi';

interface BackupInfo { backups: string[]; latest: string | null }

export function BackupsPage() {
  const { get } = useApi();
  const [data, setData] = useState<BackupInfo | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    get('/backups')
      .then(setData)
      .catch((e: unknown) => setError(String(e)));
  }, []);

  if (error) return <Card><p>Error loading backups: {error}</p></Card>;
  if (!data) return <Card><p>Loading…</p></Card>;

  const formatTs = (path: string) =>
    path.replace('firestore/', '').replace(/-/g, ':').replace(/T/, ' ');

  return (
    <div>
      <h1>Backups</h1>
      <Card>
        <p data-testid="backup-count"><strong>{data.backups.length}</strong> backups</p>
        <p>Latest: <strong>{data.latest ? formatTs(data.latest) : '—'}</strong></p>
      </Card>
      <Card>
        <h2>All backups</h2>
        <ul>
          {data.backups.map((b) => (
            <li key={b}>{b}</li>
          ))}
        </ul>
      </Card>
    </div>
  );
}
